module.exports = __webpack_public_path__ + "static/media/divorce.6da82b11.png";